<template>
  <div
    ref="dropdown"
    class="dropdown"
    role="button"
  >
    <button
      type="button"
      class="block c-white c-bg-transparent"
      @click="toggleDropdown"
    >
      {{ category }}
      <i
        :style="{ backgroundImage: showMenu ? 'url(/assets/icons/chevron-up.svg)' : 'url(/assets/icons/chevron-down.svg)' }"
      />
    </button>
    <no-ssr>
      <div
        v-if="showMenu"
        class="dropdown-content align-left lh20 regular"
      >
        <ul class="p0">
          <li
            v-for="(item, index) in list"
            :key="index"
            class="px9 dropdown-item"
            @click="$emit('close-sidebar')"
          >
            <router-link
              class="block no-underline"
              :to="categoryLink(item)"
            >
              {{ item.name }}
            </router-link>
          </li>
        </ul>
      </div>
    </no-ssr>
  </div>
</template>

<script>
import { formatCategoryLink } from '@vue-storefront/core/modules/url/helpers'
import NoSSR from 'vue-no-ssr'

export default {
  components: {
    'no-ssr': NoSSR
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    category: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showMenu: false
    }
  },
  mounted () {
    document.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    toggleDropdown () {
      this.showMenu = !this.showMenu
    },
    handleOutsideClick (event) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.showMenu = false
      }
    },
    categoryLink (category) {
      return formatCategoryLink(category)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/base/global_vars';
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$color-icon-hover: color(black);

.dropdown {
  border-radius: 12px;

  button {
    width: 100%;
    display: flex;
    font-size: 18px;
    line-height: 22px;
    font-weight: 700;
    padding: 16px 4px;
    justify-content: space-between;
    border-bottom: 1px solid #626262;

    i {
      margin-left: 6px;
      display: inline-flex;
      align-self: center;
      justify-self: flex-end;
      width: 24px;
      height: 24px;
      background-image: url('/assets/icons/chevron-down.svg');
    }
  }

  .dropdown-content {
    width: 100%;
  }

  .dropdown-item {
    width: 100%;
    padding: 16px;
    list-style: none;
    border-bottom: solid 1px #626262;

    * {
      color: #ddd;
    }
  }

  &:focus .dropdown-content {
    display: block;
  }

  &:focus-within {
    .dropdown-content {
      display: block;
    }
  }

  &.open .dropdown-content {
    display: block;
  }
}

</style>
